const faqData = [
  {
    id: "first",
    title: "What is Zaika?",
    description:
      "Zaika is a food delivery web application developed from scratch using React and Redux Toolkit. It allows users to conveniently order food from various restaurants and explore diverse cuisines.",
  },
  {
    id: "second",
    title: "Why did you choose React and Redux Toolkit for Zaika?",
    description:
      " React provides a flexible and efficient way to build user interfaces, and Redux Toolkit simplifies state management. Together, they enhance the development process, making Zaika a responsive and dynamic web app.",
  },
  {
    id: "third",
    title: "Tell us about the bundler and tools used in the project.",
    description:
      "Zaika is bundled using Parcel, a fast, zero-config web application bundler. The integration of Babel ensures seamless compatibility with the latest ECMAScript standards, enhancing code readability and maintainability.",
  },
  {
    id: "fourth",
    title: "How is data fetched in Zaika?",
    description:
      "Data is fetched from Swiggy's live API, providing real-time information about restaurants, menus, and other details. This ensures that users get the latest and most accurate data when using Zaika.",
  },
  {
    id: "fifth",
    title: "What features does Zaika offer?",
    description:
      "Zaika allows users to browse restaurants, view menus, and place food orders. The integration of Redux Toolkit ensures efficient state management, providing a seamless and interactive user experience.",
  },
  {
    id: "sixth",
    title: "How is responsive design implemented in Zaika?",
    description:
      "Zaika employs responsive design principles to ensure a seamless user experience across various devices and screen sizes. This involves using CSS media queries and flexbox/grid layouts to adapt the UI components dynamically. Responsive design in Zaika aims to provide an optimal viewing and interaction experience for users on desktops, tablets, and mobile devices.",
  },
];

export default faqData;